//import React from 'react'
import { formatDate } from "../../util"

const Date = ({ info, value }) => formatDate(value, "ro", info.fieldInfo.showTime)

export default Date
